import { defineStore } from "pinia";
import { callApi } from "src/utils/apiRequestHandler";
import { Platform, colors, getCssVar, setCssVar } from "quasar";
import { inIframe, buildManifest } from "src/utils";
import { usePersistedStore } from "./persisted-store";
import { setAccountInHeader } from "src/boot/axios";
import { sendMessageToParentApp } from "src/utils";
import { IFrameActions } from "src/constants";
import { getAccountID } from "src/utils/commonFunction";
import { useUserInfo } from "./user-store";
let listening = false;

export const useCommonStore = defineStore("common", {
  state: () => ({
    alreadyJoinStore: [],
    selectedStore: {},
    showInstallAppBanner: false,
    defaultHeader: {
      showHeader: true,
      homePageHeader: true,
      showPoints: true,
      showAvatar: true,
      showBack: true,
      Title: "Loyal-N-Save",
    },
    header: {},
    avatars: {},
    backHistories: [],
    isBackEvent: false,
    showFullScreenLoader: false,
    clearHistory: false,
    searchKeyword: "",
    headerSearch: false,
    globalSearch: false,
    globalSearchValue: "",
    globalSearchData: [],
    storeDetails: {},
    appLoaded: false,
    appInIframe: false,
    ftxCoreAccountId: null,
    storeConfigurationLoaded: false,
    initialPage: null,
  }),
  getters: {
    getHeader() {
      return Object.keys(this.header).length ? this.header : this.defaultHeader;
    },
    getAvatarList: (state) => {
      return state.avatars;
    },
    getBackRoute() {
      return this.backHistories.length
        ? this.backHistories[this.backHistories.length - 1]
        : null;
    },
    blnClearHistory() {
      return this.clearHistory;
    },
    showFullLoading() {
      return this.showFullScreenLoader;
    },
    getGlobalSearchText() {
      return this.globalSearchValue;
    },
    selectedStoreIDForeSearch: (state) => {
      return getAccountID() || state.selectedStore?.id || null;
    },
    selectedStoreName: (state) => {
      // 1️⃣ If already available
      if (state.selectedStore?.company) {
        return state.selectedStore.company;
      }

      // 2️⃣ Try finding from store list using id
      if (state.selectedStore?.id && state.alreadyJoinStore?.length) {
        const store = state.alreadyJoinStore.find(
          (s) => s.id === state.selectedStore.id
        );
        return store?.company || null;
      }

      // 3️⃣ If nothing found
      return null;
    },
  },
  actions: {
    clearSelectedStore() {
      const userDetails = useUserInfo();
      if (userDetails?.user_info?.id) {
        const key = `selectedStore-${userDetails?.user_info?.id}`;
        localStorage.removeItem(key);
      }
      this.selectedStore = null;
    },
    selectStoreForGlobal(store) {
      this.selectedStore = store;
      const userDetails = useUserInfo();
      if (store && userDetails?.user_info?.id) {
        localStorage.setItem(
          `selectedStore-${userDetails.user_info.id}`,
          JSON.stringify(store)
        );
      }
    },
    setHeader(properties) {
      this.header = Object.assign({}, properties);
    },
    setHeaderTitle({ title, params = {} }) {
      let properties = {
        ...this.header,
        ...params,
        title,
      };

      this.header = Object.assign({}, properties);
    },
    async getAvatars() {
      try {
        let data = await this.$request.get(this.apiEndpoints.AVATARS);
        if (data && data.data) {
          this.avatars = data.data.items;
        }
      } catch (error) {}
    },
    addInHistory(history) {
      this.backHistories.push(history);
    },
    clearAllHistory() {
      this.backHistories.splice(0);
    },
    setClearHistory(value) {
      this.clearHistory = value;
    },
    popFromHistory() {
      this.backHistories.pop();
    },
    setBackEvent(value) {
      this.isBackEvent = value;
    },
    setLoader(value) {
      this.showFullScreenLoader = !!value;
    },
    updateSearchkeyword(value) {
      this.searchKeyword = value;
    },
    toggleHeaderSearch(value) {
      this.headerSearch = value;
    },
    toggleGlobalSearch(params) {
      this.globalSearch = params.showGlobalSearch;
      this.globalSearchValue = params.searchText;
    },
    async fetchGlobalSearchData(searchVal) {
      let data = await callApi(() => {
        return this.$request.post(this.apiEndpoints.FRIEND_SEARCH, {
          query: searchVal,
          enforce_age_restrictions: 1,
        });
      });

      if (data && data.data && data.data.status) {
        this.globalSearchData = data.data;
      } else {
        this.globalSearchData = [];
      }
    },
    resetGlobalSearchData() {
      this.globalSearchData = [];
    },
    async getStoreConfiguration(forced = false) {
      if (this.storeConfigurationLoaded && !forced) return;
      this.storeDetails = {};

      let data = await callApi(() => {
        let params = {};
        if (this.ftxCoreAccountId) params["ftx-acc"] = this.ftxCoreAccountId;
        return this.$request.get(this.apiEndpoints.STORE_CONFIGURATION, {
          params,
        });
      });

      // console.log(data);
      if (!this.appInIframe && !Platform?.is?.cordova)
        buildManifest(data?.data?.items || null);

      if (data?.data?.status) {
        if (data.data.items) {
          this.storeDetails = data.data.items;

          this.appInIframe &&
            setAccountInHeader(data.data.items?.account_id || null);

          if (this.appInIframe && data.data.items?.firebase_config) {
            sendMessageToParentApp({
              action: "FIREBASE_CONFIG",
              value: data.data.items.firebase_config,
            });
          }
        }

        if (this.storeDetails && Object.keys(this.storeDetails).length) {
          if (
            this.storeDetails.hasOwnProperty("primary_color") &&
            this.storeDetails.primary_color &&
            this.storeDetails.primary_color.length
          ) {
            setCssVar("primary", this.storeDetails.primary_color);

            const primary_light = colors.lighten(
              this.storeDetails.primary_color,
              15
            );
            setCssVar("primary-light", primary_light);
            setCssVar("tabactivebg", primary_light);

            const primary_bg_1 = colors.lighten(
              this.storeDetails.primary_color,
              95
            );
            setCssVar("primary-bg-1", primary_bg_1);
          }
          if (
            this.storeDetails.hasOwnProperty("secondary_color") &&
            this.storeDetails.secondary_color &&
            this.storeDetails.secondary_color.length
          ) {
            setCssVar("secondary", this.storeDetails.secondary_color);
          }
        }
        //Set Fav Icon when api is loaded for the whitelabel and tenancy is reolved for whitelabel Web
        this.setFavIcon();
        this.syncSystemBarsWithTheme();
        this.storeConfigurationLoaded = true;
        return data.data;
      } else {
        //Set Fav Icon when api is loaded but tenancy is not resolved for the LNS Web
        this.setFavIcon();
        this.syncSystemBarsWithTheme();
        this.storeConfigurationLoaded = true;
        return { status: false };
      }
    },
    setFavIcon() {
      if (
        this.storeDetails.hasOwnProperty("app_icon") &&
        this.storeDetails.app_icon &&
        this.storeDetails.app_icon.length
      ) {
        var link = document.querySelector("link[rel~='icon']");
        if (!link) {
          link = document.createElement("link");
          link.rel = "icon";
          document.head.appendChild(link);
        }
        link.href = this.storeDetails.app_icon;
      } else {
        var link = document.querySelector("link[rel~='icon']");
        if (!link) {
          link = document.createElement("link");
          link.rel = "icon";
          document.head.appendChild(link);
        }
        link.href = "accountLogo/app-icon.png";
      }
    },
    setAppLoaded(appLoaded) {
      this.appLoaded = !!appLoaded;
    },
    async mapInIframe() {
      const persistedStore = usePersistedStore();
      let appInIframe = inIframe();
      if (appInIframe) this.appInIframe = true;
      else this.appInIframe = false;

      if (appInIframe && !listening)
        return new Promise((resolve) => {
          window.addEventListener("message", async (event) => {
            const message = event?.data,
              action = message?.action,
              value = message?.value;

            switch (action) {
              case "INITIAL_LNS_DATA":
                this.ftxCoreAccountId = value.accountID;
                this.initialPage = value.startUrl || null;
                await persistedStore.addUser(value.ftxCoreUser);
                resolve();
                break;
            }
          });
          sendMessageToParentApp({
            action: IFrameActions.LNS_LOADED,
          });
          listening = true;

          // const urlParams = new URLSearchParams(window.location.search);
          // const ftxCoreUser = urlParams.get("ftxCoreUser");
          // const ftxCoreAccountId = urlParams.get("ftxCoreAccountId");
          // const persistedStore = usePersistedStore();
          // this.ftxCoreAccountId = ftxCoreAccountId;

          // ftxCoreUser &&
          //   (await persistedStore.addUser(JSON.parse(decodeURI(ftxCoreUser))));
        });

      return null;
    },

    syncSystemBarsWithTheme() {
      if (Platform.is.android && window.NavigationBar) {
        try {
          const primaryColor = getCssVar("primary");
          if (primaryColor) {
            // Set navigation bar background color
            window.NavigationBar.backgroundColorByHexString(primaryColor);
          }
        } catch (err) {
          console.warn("NavigationBar error:", err);
        }
      }
    },
    async getAlMyStores() {
      const persistedStore = usePersistedStore();
      if (!persistedStore.user || !persistedStore.user.access_token) return;
      try {
        this.alreadyJoinStore = [];
        let response = await this.$request.get(
          this.apiEndpoints.MY_STORE + "isTenant=1"
        );
        if (response.data) {
          this.alreadyJoinStore = response?.data?.items
            ? response?.data?.items
            : [];
        }

        const userDetails = useUserInfo();
        const userId = userDetails?.user_info?.id;

        if (!userId) return response.data;

        const storageKey = `selectedStore-${userId}`;
        const savedStoreRaw = localStorage.getItem(storageKey);
        let validStore = null;

        if (savedStoreRaw) {
          const savedStore = JSON.parse(savedStoreRaw);

          // ✅ Check if saved store still exists
          validStore = this.alreadyJoinStore.find(
            (store) => store.id === savedStore.id
          );
        }

        if (validStore) {
          this.selectStoreForGlobal(validStore);
        } else if (this.alreadyJoinStore.length > 0) {
          // ✅ fallback to first store
          const fallbackStore = this.alreadyJoinStore[0];
          this.selectStoreForGlobal(fallbackStore);
        } else {
          // ✅ no stores at all
          this.selectedStore = null;
          localStorage.removeItem(storageKey);
        }

        return response.data;
      } catch (error) {
        return {};
        // console.log("FromAPI:-" + error);
      }
    },
  },
});
